import classNames from 'classnames';
import * as React from 'react';
import type { EducationSearchItem } from '../../../Search/Education/Service/EducationSearchItem.csharp';
import type { SearchResultResponse } from '../../../Search/SearchResultResponse.csharp';
import { StudyCard } from '~/Features/Partials/StudyCard/StudyCard';
import { mapToStudyCardProps } from '~/Pages/StudyListPage/StudyListSearch/studyListSearchUtils';
import { CollapseFilters } from '~/Partials/Filters/CollapseFilters';
import { FacetsAccordionList } from '~/Partials/Filters/Facets/FacetsAccordionList';
import { SimpleFilters } from '~/Partials/Filters/SimpleFilters';
import { PagedFetchData } from '~/Partials/PagedFetchData/PagedFetchData';
import type { SearchState } from '~/Partials/SearchBase/SearchBase';
import { SearchBase } from '~/Partials/SearchBase/SearchBase';
import searchBaseStyles from '~/Partials/SearchBase/SearchBase.module.css';
import { SearchBox } from '~/Partials/SearchBox/SearchBox';
import { SelectedFiltersList } from '~/Partials/SelectedFiltersList/SelectedFiltersList';
import styles from './StudyListSearch.module.css';
import { StudyListSearchResultItem } from './StudyListSearchResultItem/StudyListSearchResultItem';
import type { StudyListSearchViewModel } from './StudyListSearchViewModel.csharp';

export class StudyListSearch extends SearchBase<StudyListSearchViewModel, SearchState> {
    render() {
        const { facets, translations, showStudyCardsInResults, searchUrl } = this.props;
        const { selectedFacets } = this.state.searchParams;

        return (
            <div className={searchBaseStyles.SearchBase}>
                <div>
                    <div>
                        <SearchBox
                            variant="fullWidth"
                            withPageWrapper
                            value={this.state.searchParams.phrase}
                            placeholder={translations.searchForStudies}
                            onChange={event => this.handleQueryChange(event.target.value)}
                        />
                        <div className={searchBaseStyles['Filters--mobile']}>
                            <CollapseFilters
                                translations={translations}
                                filters={
                                    <FacetsAccordionList
                                        facets={facets}
                                        selectedFacets={selectedFacets}
                                        handleFacetChange={this.handleFacetChange}
                                    />
                                }
                            />
                        </div>
                    </div>
                    <SelectedFiltersList
                        facets={facets}
                        selectedFacets={this.state.searchParams.selectedFacets}
                        removeFilterDescription={translations.removeFilter}
                        onRemoveFacet={this.handleFacetChange}
                    />
                </div>
                <div className={classNames(searchBaseStyles['Filters--desktop'])}>
                    <SimpleFilters translations={translations}>
                        <FacetsAccordionList
                            facets={facets}
                            selectedFacets={selectedFacets}
                            handleFacetChange={this.handleFacetChange}
                            initialExpanded
                        />
                    </SimpleFilters>
                </div>
                <div
                    className={classNames(
                        styles.Results,
                        searchBaseStyles.Results,
                        showStudyCardsInResults && styles['Results--withCards']
                    )}
                >
                    <h2 className="visuallyHidden">{translations.results}</h2>
                    <PagedFetchData<SearchResultResponse<EducationSearchItem>, EducationSearchItem>
                        baseUrl={searchUrl}
                        searchParams={this.getBaseSearchQueryParameters(this.state.searchParams)}
                        debounceTime={200}
                        take={24}
                        translations={{ ...translations }}
                        listClassName={styles.ResultsList}
                    >
                        {({ data }) =>
                            showStudyCardsInResults ? (
                                <StudyCard {...mapToStudyCardProps(data)} />
                            ) : (
                                <StudyListSearchResultItem value={data} />
                            )
                        }
                    </PagedFetchData>
                </div>
            </div>
        );
    }
}
